import { getFromLocalStorage } from '../../hooks/useLocalStorage';
import { UPDATE_POLICY_PAYLOAD, UPDATE_POLICY_PAYLOAD_RESET, UPDATE_POLICY_PAYLOAD_SUCCESS } from '../actionTypes'


export const policyInitialState = {
    vehicle: {
        vin: '',
        selling_person: getFromLocalStorage("user")?.name,
        location: '',
        brand: '',
        model: '',
        variant: '',
        fuel: '',
        transmission: '',
        category: '',
        regNo: '',
        saleDate: '',
        saleStartDate: '',
        odometer: '',
        second_sale_date: "",
        demo_car: "",
        ew_doc: "",
        end_date: "",
        motor_serial_number: '',
        ew_period: '',
        battery_serial_number: ''
    },
    user: {
        name: '',
        email: '',
        mobile: '',
        address: '',
        country: '',
        pin_code: '',
        state: '',
        city: '',
        invoiceType: '',
        gst: '',
        gstn_number_last_three_digit: "",
        pan: '',
    },
    product: { product_id: '', product_name: '', sales_category_id: '', amount: 0 , policyId: '',product_details: {},products: [] },
    payment_mode: '',
    payment_amount: '',
    user_id: '',
    policyId: '',
    hash: '',
    txnid: '',
}

export default (state = policyInitialState, action) => {
    switch (action.type) {
        case UPDATE_POLICY_PAYLOAD:
            return { ...state, ...action.payload?.policy };
        case UPDATE_POLICY_PAYLOAD_SUCCESS:
            return { ...state, ...action.payload };
        case UPDATE_POLICY_PAYLOAD_RESET:
            return { ...state, ...policyInitialState };
        default: return state;
    }

}